import { render, staticRenderFns } from "./FormControlAccountSettingsReorderScripts.vue?vue&type=template&id=589ff3c8&scoped=true"
import script from "./FormControlAccountSettingsReorderScripts.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlAccountSettingsReorderScripts.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlAccountSettingsReorderScripts.vue?vue&type=style&index=0&id=589ff3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ff3c8",
  null
  
)

export default component.exports